// api.js

import axiosInstance from "../axiosInstance";

export const providerService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/provider", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, searchValue, type) => {
    try {
      let api = `/provider?&$limit=${limit || 15}&$skip=${skip || 0}`;
      if (searchValue) {
        api += `&name[$search]=${searchValue}`;
      }
      if (type) {
        api += `&type=${type}`;
      }
      let response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(`/provider/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/provider/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
